// extracted by mini-css-extract-plugin
module.exports = {"form_container":"RecoverPassword_form_container__3yVXF","login_page_container":"RecoverPassword_login_page_container__fJcCI","language":"RecoverPassword_language__HeCuk"};